export default __webpack_public_path__ + "static/media/folder.e77138fa.svg";